(function () {
  if (window.ibAdDecisionInitialized) return;
  window.ibAdDecisionInitialized = true;

  const blockedCountries = new Set([
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU',
    'IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES',
    'SE'
  ]);

  const geoEndpoint = 'https://geo.innerbuddies.com/country';

  function getBlocks() {
    return Array.from(document.querySelectorAll('.ib-ad-decision-block'));
  }

  function showFallbackForAllBlocks() {
    getBlocks().forEach(function (block) {
      const adsenseContainer = block.querySelector('.ib-adsense-container');
      const fallbackBlock = block.querySelector('.ib-ad-fallback');

      if (adsenseContainer) {
        adsenseContainer.style.display = 'none';
        adsenseContainer.innerHTML = '';
      }

      if (fallbackBlock) {
        fallbackBlock.style.display = 'block';
      }
    });
  }

  function loadAdsenseScript(adClient) {
    return new Promise(function (resolve, reject) {
      if (window.ibAdsenseScriptLoaded) {
        resolve();
        return;
      }

      window.ibAdsenseScriptLoaded = true;

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=' + encodeURIComponent(adClient);
      script.crossOrigin = 'anonymous';

      script.onload = resolve;
      script.onerror = reject;

      document.head.appendChild(script);
    });
  }

  function showAdsenseForAllBlocks() {
    const blocks = getBlocks();

    if (!blocks.length) return;

    const firstAdsenseContainer = blocks[0].querySelector('.ib-adsense-container');

    if (!firstAdsenseContainer) {
      showFallbackForAllBlocks();
      return;
    }

    const firstAdClient = firstAdsenseContainer.getAttribute('data-ad-client');

    if (!firstAdClient) {
      showFallbackForAllBlocks();
      return;
    }

    loadAdsenseScript(firstAdClient)
      .then(function () {
        blocks.forEach(function (block) {
          const adsenseContainer = block.querySelector('.ib-adsense-container');
          const fallbackBlock = block.querySelector('.ib-ad-fallback');

          if (!adsenseContainer) {
            if (fallbackBlock) fallbackBlock.style.display = 'block';
            return;
          }

          const adClient = adsenseContainer.getAttribute('data-ad-client');
          const adSlot = adsenseContainer.getAttribute('data-ad-slot');

          if (!adClient || !adSlot) {
            if (fallbackBlock) fallbackBlock.style.display = 'block';
            return;
          }

          if (adsenseContainer.dataset.loaded === 'true') return;

          if (fallbackBlock) {
            fallbackBlock.style.display = 'none';
          }

          adsenseContainer.style.display = 'block';
          adsenseContainer.dataset.loaded = 'true';

          const ins = document.createElement('ins');
          ins.className = 'adsbygoogle';
          ins.style.display = 'block';
          ins.style.textAlign = 'center';

          ins.setAttribute('data-ad-layout', 'in-article');
          ins.setAttribute('data-ad-client', adClient);
          ins.setAttribute('data-ad-slot', adSlot);
          ins.setAttribute('data-ad-format', 'fluid');
          ins.setAttribute('data-full-width-responsive', 'true');

          adsenseContainer.appendChild(ins);

          try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          } catch (e) {}
        });
      })
      .catch(function () {
        showFallbackForAllBlocks();
      });
  }

  fetch(geoEndpoint, {
    method: 'GET',
    credentials: 'omit',
    cache: 'no-store'
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Geo lookup failed');
      return response.json();
    })
    .then(function (data) {
      const country = String(data.country || '').toUpperCase();

      window.ibVisitorCountry = country;
      window.ibShowAdsense = false;

      if (!country || country === 'XX' || country === 'T1') {
        showFallbackForAllBlocks();
        return;
      }

      if (blockedCountries.has(country)) {
        showFallbackForAllBlocks();
        return;
      }

      window.ibShowAdsense = true;
      showAdsenseForAllBlocks();
    })
    .catch(function () {
      window.ibShowAdsense = false;
      showFallbackForAllBlocks();
    });
})();
